/*
 * @Author: Teemo Ding
 * @Date: 2021-06-23 11:52:55
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 09:24:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/StoreDetails/Organisation/index.tsx
 */
import {
  Input,
  Label, //Select,
  TextArea,
} from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
//import { Icon } from '@/src/tools/icon';
import { Icon } from '@/src/tools/icon';
import {
  //Divider,
  Form,
} from 'antd';
import React from 'react';
import css from '../css.module.less';
import {
  //MobileNumber,
  AreaCodeInfo,
  PhoneNumber,
} from 'src/pages/CustomerDatabaseConfig/Components/CustomerInfoModal';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Organisation = (props: any) => {
  const {
    countries,
    states, // defaultAreaText,
    disabled,
  } = props;
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const c1 = (countries || []).filter((i) => {
    return i.areaCode === '852' || i.areaCode === '853' || i.areaCode === '86';
  }); //暂时修改，areacode全部修改已经完成

  const areaCodesOptions = c1.map((item) => ({
    value: `+${item.areaCode}`,
    label: `${item.name} (+${item.areaCode})`,
  }));

  const countriesOptions = countries.map((item) => ({
    code: item.code,
    name: item.name,
  }));

  const statesOptions = states.map((item) => ({
    uuid: item.uuid,
    name: item.name,
  }));

  return (
    <SectionWrapper
      titleClassName={css.titleContainerAll}
      title={getI18n('storeDetailsSetting.detail.organisation')}
      subtitle={getI18n(
        'storeDetailsSetting.detail.theseinformationwillshowonyourinvoice.',
      )}
      className={css.storeDetailsInfo}>
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='entityName'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storeDetailsSetting.detail.entityName',
                    )} *`}
                  />
                }
                rules={[
                  { required: true, message: 'Please input Store Name!' },
                ]}>
                <Input size='large' disabled={disabled} />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='entityRegistrationNumber'
                label={
                  <Label
                    title={getI18n(
                      'storeDetailsSetting.detail.entityRegistrationNumber',
                    )}
                  />
                }
                labelCol={{
                  span: 24,
                }}>
                <Input size='large' disabled={disabled} />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                labelCol={{
                  span: 24,
                }}
                className={css.phone}
                label={
                  <Label title={getI18n('general.customer.phoneNumber')} />
                }
                rules={[
                  { required: true, message: 'Please input Store Name!' },
                ]}>
                <Form.Item name='areaCodeInfo'>
                  <AreaCodeInfo disabled={disabled} />
                </Form.Item>
                <Form.Item name='phone' style={{ flex: 1 }}>
                  {/* <Input size='large' disabled={disabled} /> */}
                  <PhoneNumber
                    disabled={disabled}
                    className={css.phoneNumber}
                    suffixIcon={<Icon type='icondown' className={css.icon} />}
                    getPopupContainer={(trigger) => trigger}
                    optionsList={areaCodesOptions}
                    optionLabelProp='label'
                    dropdownClassName={css.dropdown}
                    dropdownRender={(menu) => (
                      <div>
                        {/* {defaultAreaText && (
                          <div className={css.defaultAreaCode}>
                            {defaultAreaText}
                          </div>
                        )} */}
                        {/* {defaultAreaText && (
                          <Divider
                            className={css.divider}
                            style={{ margin: '4px 0' }}
                          />
                        )} */}
                        {menu}
                      </div>
                    )}
                  />
                </Form.Item>
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='email'
                label={<Label title={getI18n('general.customer.email')} />}
                rules={[
                  { type: 'email', message: getI18n('general.invalidformat') },
                ]}
                labelCol={{
                  span: 24,
                }}>
                <Input size='large' disabled={disabled} />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='addressLine'
                label={
                  <Label
                    title={`${getI18n(
                      'storeDetailsSetting.detail.addressLine',
                    )} *`}
                  />
                }
                labelCol={{
                  span: 24,
                }}
                rules={[
                  { required: true, message: 'Please input Address Line!' },
                ]}>
                <TextArea autoSize={{ minRows: 4 }} disabled={disabled} />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='country'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storeDetailsSetting.detail.country/Region',
                    )} *`}
                  />
                }
                rules={[
                  { required: true, message: 'Please input Country/Region!' },
                ]}>
                <SelectObjectAsValue
                  objectAsValue
                  size='large'
                  disabled={true}
                  getPopupContainer={(trigger) => trigger}
                  valueKey='code'
                  labelKey='name'
                  options={countriesOptions}
                />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='subdivision'
                label={
                  <Label
                    title={`${getI18n(
                      'storeDetailsSetting.detail.state/Province/District',
                    )} *`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: 'Please input State/Province/District!',
                  },
                ]}
                labelCol={{
                  span: 24,
                }}>
                <SelectObjectAsValue
                  objectAsValue
                  size='large'
                  getPopupContainer={(trigger) => trigger}
                  valueKey='uuid'
                  labelKey='name'
                  options={statesOptions}
                  disabled={disabled}
                />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='postCode'
                label={
                  <Label
                    title={`${getI18n(
                      'storeDetailsSetting.detail.postcode/Zip',
                    )}`}
                  />
                }
                labelCol={{
                  span: 24,
                }}>
                <Input size='large' disabled={disabled} />
              </Form.Item>
            ),
          },
        ]}
      />
    </SectionWrapper>
  );
};

export default Organisation;
